import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from 'react-bootstrap/Spinner';
import { toast, ToastContainer } from 'react-toastify';
import { Link } from "react-router-dom";
import StockNavbar from './StockNavbar';
import item_list from '../../assets/images/dashboard_icon/item_list.svg';
import items_issued from '../../assets/images/dashboard_icon/items_issued.svg';
import negative_stock from '../../assets/images/dashboard_icon/negative_stock.svg';
import clipboard from '../../assets/images/dashboard_icon/clipboard.svg';
import fixed_money from '../../assets/images/dashboard_icon/fixed_money.svg';
import current_money from '../../assets/images/dashboard_icon/current_money.svg';
import consumable_money from '../../assets/images/dashboard_icon/consumable_money.svg';

const StocksDashboard = () => {

    const manageUrl = (query) => `/StockManagement/ManageStockCategory?${query}`;

    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
    const [dData, setdData] = useState({});
    const [loading, setLoading] = useState(true);

    const fmtCount = (n) => (n == null || n === "" ? "0" : Number(n).toLocaleString());
    const fmtMoney = (n) => {
        if (n == null || n === "") return "0";
        const num = Number(n);
        if (Number.isNaN(num)) return "0";
        return num.toLocaleString(undefined, { maximumFractionDigits: 0 });
    };

    useEffect(() => {
        document.title = "Stocks Dashboard";
        setLoading(true);

        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
        };
        var api_config = {
            method: 'post',
            url: config.base_url + 'Stock/GetStockDashboard',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios(api_config)
            .then(function (response) {
                if (response.data.status_code == 1) {
                    setdData(response.data);
                } else {
                    setdData({});
                    if (response.data.status_message) {
                        toast.error(response.data.status_message, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                    }
                }
                setLoading(false);
            })
            .catch(function () {
                setLoading(false);
                setdData({});
                toast.error('Network Error..', {
                    position: toast.POSITION.TOP_RIGHT
                });
            });
    }, [AccessKey, UserID, MemberType]);


    return (
        <>
            <StockNavbar />
            <ToastContainer />
            <div className="page-head">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/Dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Stocks</li>
                                </ol>
                            </nav>
                            <div className="page-title">Stocks</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="page-content">
                <div className="container">
                    {loading ? (
                        <div className="text-center py-5">
                            <Spinner animation="border" role="status" />
                        </div>
                    ) : (
                    <div className="row align-items-center gy-3">
                        <div className="col-md-3 col-sm-6">
                            <Link to={manageUrl("")} className="text-decoration-none text-dark">
                            <div className="card m-card h-100">
                                <div className="card-body text-center">
                                    <img src={item_list} className="pb-3" alt="" />
                                    <p className="m-2">Total Items in Stock</p>
                                    <h4 className="m-2">{fmtCount(dData.totalItemsinStock)}</h4>
                                </div>
                            </div>
                            </Link>
                        </div>
                        <div className="col-md-3 col-sm-6">
                            <Link to="/StockManagement/StockMovementReport" className="text-decoration-none text-dark">
                            <div className="card m-card h-100">
                                <div className="card-body text-center">
                                    <img src={items_issued} className="pb-3" alt="" />
                                    <p className="m-2">Items issued this month (OUT)</p>
                                    <h4 className="m-2">{fmtCount(dData.itemIssuesinMonth)}</h4>
                                    <p className="small text-muted mb-0">
                                        Received (IN): {fmtCount(dData.itemsReceivedinMonth)}
                                    </p>
                                </div>
                            </div>
                            </Link>
                        </div>
                        <div className="col-md-3 col-sm-6">
                            <Link to={manageUrl("negativeOnly=1")} className="text-decoration-none text-dark">
                            <div className="card h-100">
                                <div className="card-body text-center">
                                    <img src={negative_stock} className="pb-3" alt="" />
                                    <p className="m-2">Negative Stock Items</p>
                                    <h4 className="m-2">{fmtCount(dData.negativeStockItems)}</h4>
                                </div>
                            </div>
                            </Link>
                        </div>
                        <div className="col-md-3 col-sm-6">
                            <Link to={manageUrl("")} className="text-decoration-none text-dark">
                            <div className="card h-100">
                                <div className="card-body text-center">
                                    <img src={clipboard} className="pb-3" alt="" />
                                    <p className="m-2">Total Value of Available Stock</p>
                                    <h4>{fmtMoney(dData.totalValueOfStock)}</h4>
                                </div>
                            </div>
                            </Link>
                        </div>
                        <div className="col-md-12">
                            <div className="card m-card">
                                <div className="card-body">
                                    <div className="row align-items-center gy-3 m-auto">
                                        <p className="m-0">
                                            <b>Register Type Stock</b>
                                        </p>
                                        {(dData.registerTypeSummary && dData.registerTypeSummary.length > 0
                                            ? dData.registerTypeSummary
                                            : []
                                        ).map((reg, idx) => (
                                        <div className="col-md-4 col-sm-12" key={reg.RegisterName || idx}>
                                            <Link
                                                to={manageUrl(`Register_Type=${encodeURIComponent(reg.RegisterName)}`)}
                                                className="text-decoration-none text-dark"
                                            >
                                            <div className="card h-100" style={{ backgroundColor: "#f9f9f9" }}>
                                                <div className="card-body text-center">
                                                    <img src={consumable_money} className="pb-3" alt="" />
                                                    <p className="m-2"><b>{reg.RegisterName}</b></p>
                                                    <div className="row align-items-center gy-2">
                                                        <div className="col-md-6">
                                                            <p className="m-0 text-left"> No. of Items</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <span className="pink-value">{fmtCount(reg.ItemCount)}</span>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <p className="m-0 text-left">Value of Stock</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <span className="pink-value">{fmtMoney(reg.StockValue)}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            </Link>
                                        </div>
                                        ))}
                                        {(!dData.registerTypeSummary || dData.registerTypeSummary.length === 0) && (
                                            <div className="col-12">
                                                <p className="text-muted small mb-0">
                                                    No register types configured.{" "}
                                                    <Link to="/StockManagement/ManageStockRegisterTypes">Add register types</Link>
                                                </p>
                                            </div>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    )}
                </div>
            </div>
        </>
    );
}

export default StocksDashboard;
